module.exports = __webpack_public_path__ + "static/media/aws.c158a2e0.png";